export enum rbacActions {

    GetDashboard = 'GetDashboard',
    GetAccountSettings = 'GetAccountSettings',
    GetAnalytics = 'GetAnalytics',
    GetAdministration = 'GetAdministration',

    ListAliases = 'ListAliases',
    GetAlias = 'GetAlias',
    CreateAlias = 'CreateAlias',
    UpdateAlias = 'UpdateAlias',
    DeleteAlias = 'DeleteAlias',

    ListContacts = 'ListContacts',
    GetContact = 'GetContact',
    CreateContact = 'CreateContact',
    UpdateContact = 'UpdateContact',
    DeleteContact = 'DeleteContact',

    ListMessages = 'ListMessages',
    GetMessage = 'GetMessage',
    CreateMessage = 'CreateMessage',
    UpdateMessage = 'UpdateMessage',
    DeleteMessage = 'DeleteMessage',

    ListTags = 'ListTags',
    GetTag = 'GetTag',
    CreateTag = 'CreateTag',
    UpdateTag = 'UpdateTag',
    DeleteTag = 'DeleteTag',

    ListPersonas = 'ListPersonas',
    GetPersona = 'GetPersona',
    CreatePersona = 'CreatePersona',
    UpdatePersona = 'UpdatePersona',
    DeletePersona = 'DeletePersona',

    // ListServicePlans, UpdateServicePlan and DeleteServicePlan were removed here
    // (FNP-1116). No deployed AVP schema declares them, so they could never be
    // granted and every check against them failed closed, silently. Service-plan
    // gating is designed in FNP-1122, which reconciles the app's action list with
    // the deployed schema.
}

export const actions = [
    rbacActions.GetDashboard,
    rbacActions.GetAccountSettings,
    rbacActions.GetAnalytics,
    rbacActions.GetAdministration,

    rbacActions.ListAliases,
    rbacActions.GetAlias,
    rbacActions.CreateAlias,
    rbacActions.UpdateAlias,
    rbacActions.DeleteAlias,

    rbacActions.ListContacts,
    rbacActions.GetContact,
    rbacActions.CreateContact,
    rbacActions.UpdateContact,
    rbacActions.DeleteContact,

    rbacActions.ListMessages,
    rbacActions.GetMessage,
    rbacActions.CreateMessage,
    rbacActions.UpdateMessage,
    rbacActions.DeleteMessage,

    rbacActions.ListTags,
    rbacActions.GetTag,
    rbacActions.CreateTag,
    rbacActions.UpdateTag,
    rbacActions.DeleteTag,

    rbacActions.ListPersonas,
    rbacActions.GetPersona,
    rbacActions.CreatePersona,
    rbacActions.UpdatePersona,
    rbacActions.DeletePersona,

];

